<div class='ResetContentDialog d-flex flex-column'>
  <div class='flex-grow-1'>
    <p>
      Enter content code to overwrite your existing content with the content
      associated with the content code. Please note, this cannot be undone.
    </p>
  </div>
  <div class='flex-grow-1'>
    <form [formGroup]='inputForm'>
      <app-text-field
        formControlName='code'
        placeholder='Enter code'></app-text-field>
    </form>
  </div>
</div>
